export const getInputStyleByAmountLength = (
  amount: string,
  smaller?: boolean,
  currency?: string,
): React.CSSProperties => {
  const length = amount.length;

  const BASE_FONT_SIZE = smaller ? 38 : 56;

  const BASE_LENGTH = 4;

  const DECREASE_RATE = smaller ? 2 : 3;

  const MIN_FONT_SIZE = smaller ? 18 : 20;

  const CURRENCY_LENGTH_DIVISOR = 2;

  // Add one character of width for every two currency characters.
  const currencyLengthAdjustment = Math.floor(
    (currency?.length ?? 0) / CURRENCY_LENGTH_DIVISOR,
  );

  const extraCharacterCount = Math.max(
    0,
    length - BASE_LENGTH + currencyLengthAdjustment,
  );

  const fontSize = Math.max(
    MIN_FONT_SIZE,
    BASE_FONT_SIZE - extraCharacterCount * DECREASE_RATE,
  );

  return {
    fontSize: `${fontSize}px`,
  };
};
